var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRgt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 29.053c7.761 0 13.053-5.292 13.053-13.053C29.053 8.24 23.76 2.947 16 2.947 8.24 2.947 2.947 8.24 2.947 16 2.947 23.76 8.24 29.053 16 29.053zM16 31c8.284 0 15-6.716 15-15S24.284 1 16 1 1 7.716 1 16s6.716 15 15 15zm-.079-7.947c4.405 0 6.975-2.57 6.975-6.974 0-4.405-2.57-6.975-6.974-6.975-4.403 0-6.973 2.57-6.973 6.974 0 4.403 2.57 6.973 6.974 6.973zM15.922 25a8.92 8.92 0 1 0 0-17.842A8.92 8.92 0 0 0 15.922 25zm-9.657-9c0-5.93 3.807-9.737 9.737-9.737 5.93 0 9.737 3.807 9.737 9.737 0 5.93-3.807 9.737-9.737 9.737-5.93 0-9.737-3.807-9.737-9.737zm-1.947 0C4.316 9.547 9.546 4.316 16 4.316c6.453 0 11.684 5.23 11.684 11.684 0 6.453-5.23 11.684-11.684 11.684-6.453 0-11.684-5.23-11.684-11.684z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRgt);
export default __webpack_public_path__ + "static/media/RGT.e102b299fc6c7348c9f5e2167b3867c1.svg";
export { ForwardRef as ReactComponent };